import { useSelectorKiosk } from "./useSelectorKiosk";

const useFontSize = () => {
    const selector = useSelectorKiosk(state => state.fontsize)
    return selector;
}

export default useFontSize;